export default function ControlLabel(theme: any) {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        label: {},
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {},
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[400],
          "&.Mui-focused": {
            color: theme.palette.grey[400],
          },
        },
      },
    },
  };
}
